/* eslint-disable i18n/no-russian-character */
const ruPlural = {
    bonuses: ["бонус", "бонуса", "бонусов"],
    checkList: ["чек-лист", "чек-листа", "чек-листов"],
    clientCards: ["карточка", "карточки", "карточек"],
    clients: ["гость", "гостя", "гостей"],
    complaints: ["обращение", "обращения", "обращений"],
    employees: ["сотрудник", "сотрудника", "сотрудников"],
    errors: ["ошибка", "ошибки", "ошибок"],
    examinations: ["аттестация", "аттестации", "аттестаций"],
    feedback: ["отзыв", "отзыва", "отзывов"],
    goods: ["товар", "товара", "товаров"],
    grades: ["грейд", "грейда", "грейдов"],
    hours: ["час", "часа", "часов"],
    journals: ["журнал", "журнала", "журналов"],
    lessons: ["урок", "урока", "уроков"],
    numbers: ["номер", "номера", "номеров"],
    offences: ["нарушение", "нарушения", "нарушений"],
    questions: ["вопрос", "вопроса", "вопросов"],
    receipts: ["чек", "чека", "чеков"],
    records: ["запись", "записи", "записей"],
    rubs: ["рубль", "рубля", "рублей"],
    scores: ["балл", "балла", "баллов"],
    steps: ["шаг", "шага", "шагов"],
    templates: ["шаблон", "шаблона", "шаблонов"],
    unreadNews: ["непрочитанная новость", "непрочитанные новости", "непрочитанных новостей"],
    workManagerEvents: ["смена", "смены", "смен"],
};

export default ruPlural;
